import { createFileRoute, redirect } from '@tanstack/react-router'

import CreateFirstSuperUserAccountPage from '@/features/Auth/FirstSuperUser'
import { getFirstSuperUserSetupStatusHandler } from '@/features/Auth/FirstSuperUser/server.ts'
import { systemSettingsQueryOptions } from '@/lib/Queries/appQueries.ts'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/setup')({
    component: CreateFirstSuperUserAccountPage,
    errorComponent: RouteErrorComponent,
    beforeLoad: async function ({ location }) {
        const { isRequired } = await getFirstSuperUserSetupStatusHandler()

        if (!isRequired && location.pathname === '/setup') {
            throw redirect({ to: '/login' })
        }
    },
    loader: async function ({ context }) {
        await context.queryClient.ensureQueryData(systemSettingsQueryOptions())
    },
})
